import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const AlternatePhoneEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const contactInfo = useAppSelector(state => state.registration.currentRegistration?.contactInfo) || {};
  const value = contactInfo.alternatePhone || '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      contactInfo: {
        ...contactInfo,
        alternatePhone: e.target.value,
      },
    }));
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      size="small"
      label="Alternate Phone"
    />
  );
};

export default AlternatePhoneEdit;
